module.exports = __webpack_public_path__ + "static/media/em-86.71581a7d.png";